export default __webpack_public_path__ + "static/Bubbleyum_gumballsisolated-a7d579e5ae9c5ea4caac341e3748f41f.png";